module.exports = __webpack_public_path__ + "static/media/upload.00a81b70.svg";